import { Component , Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'app-module-title',
  imports: [],
  templateUrl: './module-title.component.html',
  styleUrl: './module-title.component.scss',
   changeDetection: ChangeDetectionStrategy.OnPush  
})
export class ModuleTitleComponent {
 @Input({ required: true }) moduleName!: string; 
}
